import { render, staticRenderFns } from "./ReviewClinic.vue?vue&type=template&id=03b3ea1b&"
import script from "./ReviewClinic.vue?vue&type=script&lang=js&"
export * from "./ReviewClinic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports